module.exports = __webpack_public_path__ + "img/arrow-left.b47d196c.svg";